import React, { useState, useEffect } from 'react';
import { useTranslation,Trans } from "react-i18next";

function OfferRecommendBrowserSp(props) {
	const { t } = useTranslation();

	const [browsers0, setBrowser0] = useState('');
	const [browsers1, setBrowser1] = useState('');
	const [browsers2, setBrowser2] = useState('');
	const [browsers3, setBrowser3] = useState('');

	useEffect(() => {
		setBrowserInfo();
	}, [props.language]);

	const setBrowserInfo = () => {
		setBrowser0(getBrowserList('recommendBrowser.deviceList.pc.devices.0.browser'));
		setBrowser1(getBrowserList('recommendBrowser.deviceList.pc.devices.1.browser'));
		setBrowser2(getBrowserList('recommendBrowser.deviceList.mobile.devices.0.browser'));
		setBrowser3(getBrowserList('recommendBrowser.deviceList.mobile.devices.1.browser'));
	}

	const getBrowserList = (str) => {
		//存在有無の確認
		let ret = t(str, { returnObjects: true });
		if(ret === str) {
			ret = null;
		}
		return ret;
	}
	
	return (
		<>
			<br/>
			<div className="mobile-menu__line2 sp-only"/>
			<dd className="detail-info__text sp-only"><Trans i18nKey="recommendBrowser.confirmLink" components={{ l: <a href="/confirm">link</a> }}/></dd>
			
			<dt className="detail-info__title sp-only">{t('recommendBrowser.title')}</dt>
			<dt className="detail-info__text sp-only">
				<div>
					<div className="detail-info__text-title">{t('recommendBrowser.deviceList.pc.title')}</div>
					
					{browsers0 && (
						<>
						<div className="detail-info__text-title">{t('recommendBrowser.deviceList.pc.devices.0.title')}</div>
						{browsers0.map((browser, index) => {
							return (<p key={index}>・{browser}</p>)
						})}
						</>
					)}
					{browsers1 && (
						<>
						<div className="detail-info__text-title">{t('recommendBrowser.deviceList.pc.devices.1.title')}</div>
						{browsers1.map((browser, index) => {
							return (<p key={index}>・{browser}</p>)
						})}
						</>
					)}

					<div className="detail-info__text-title">{t('recommendBrowser.deviceList.mobile.title')}</div>
					
					{browsers2 && (
						<>
						<div className="detail-info__text-title">{t('recommendBrowser.deviceList.mobile.devices.0.title')}</div>
						{browsers2.map((browser, index) => {
							return (<p key={index}>・{browser}</p>)
						})}
						</>
					)}
					{browsers3 && (
						<>
						<div className="detail-info__text-title">{t('recommendBrowser.deviceList.mobile.devices.1.title')}</div>
						{browsers3.map((browser, index) => {
							return (<p key={index}>・{browser}</p>)
						})}
						</>
					)}
				</div>
			</dt>
		</>
	);
}

export default OfferRecommendBrowserSp;
